<template>
  <div class="sidebar-content">
    <div class="chat-fixed-search">
      <div class="d-flex align-items-center w-100">
        <b-form-input
          v-model="busca"
          placeholder="Buscar por nome ou protocolo"
          class="chat-search-input"
        />
      </div>
    </div>

    <ul class="nav nav-pills nav-justified nav-abas-atendimento px-50 pt-1">
      <li v-for="item in abas" :key="item.valor" class="nav-item">
        <a
          href="#"
          class="nav-link py-50"
          :class="{ active: aba === item.valor }"
          @click.prevent="$emit('trocar-aba', item.valor)"
        >
          {{ item.rotulo }}
        </a>
      </li>
    </ul>

    <div class="chat-user-list-wrapper">
      <h6 v-if="carregando && !conversas.length" class="chat-list-title">
        Carregando...
      </h6>
      <ul v-else class="chat-users-list contact-list">
        <li
          v-for="conversa in conversasFiltradas"
          :key="conversa.id"
          :class="{ active: conversa.id === conversaAtivaId }"
          @click="$emit('selecionar', conversa.id)"
        >
          <b-avatar :text="iniciais(conversa)" size="42" />
          <div class="chat-info flex-grow-1">
            <h5 class="mb-0 text-truncate">
              {{ nomeContato(conversa) }}
            </h5>
            <p class="card-text text-truncate mb-0">
              {{ previaMensagem(conversa) }}
            </p>
            <small v-if="conversa.user" class="text-muted d-block text-truncate">
              <feather-icon icon="UserIcon" size="10" /> {{ conversa.user.name }}
            </small>
          </div>
          <div class="chat-meta text-right">
            <span class="chat-time">{{ formatarHora(conversa.updated_at) }}</span>
            <br>
            <b-badge v-if="conversa.nao_lidas" pill variant="primary" class="mt-25">
              {{ conversa.nao_lidas }}
            </b-badge>
            <small v-else-if="conversa.departamento" class="text-muted">{{ conversa.departamento.nome }}</small>
          </div>
        </li>
        <li v-if="!conversasFiltradas.length" class="no-results show">
          <span>Nenhuma conversa aqui.</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { BFormInput, BAvatar, BBadge } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: { BFormInput, BAvatar, BBadge, FeatherIcon },
  props: {
    conversas: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false },
    conversaAtivaId: { type: [Number, String], default: null },
    aba: { type: String, default: 'fila' },
  },
  data() {
    return {
      busca: '',
      abas: [
        { valor: 'todos', rotulo: 'Todos' },
        { valor: 'fila', rotulo: 'Fila' },
        { valor: 'minhas', rotulo: 'Minhas' },
        { valor: 'encerrados', rotulo: 'Encerrados' },
      ],
    }
  },
  computed: {
    conversasFiltradas() {
      if (!this.busca) return this.conversas
      const termo = this.busca.toLowerCase()
      return this.conversas.filter(conversa => {
        const nome = this.nomeContato(conversa).toLowerCase()
        return nome.includes(termo) || (conversa.protocolo || '').toLowerCase().includes(termo)
      })
    },
  },
  methods: {
    nomeContato(conversa) {
      const contato = conversa.contato || {}
      return contato.nome || contato.nome_perfil || contato.wa_id || 'Desconhecido'
    },
    iniciais(conversa) {
      const nome = this.nomeContato(conversa)
      return nome.substring(0, 2).toUpperCase()
    },
    previaMensagem(conversa) {
      const ultima = conversa.ultima_mensagem
      if (!ultima) return conversa.departamento ? conversa.departamento.nome : 'Aguardando URA'
      if (ultima.texto) return ultima.texto
      return '[' + ultima.tipo + ']'
    },
    formatarHora(dataIso) {
      if (!dataIso) return ''
      const data = new Date(dataIso)
      const hoje = new Date()
      if (data.toDateString() === hoje.toDateString()) {
        return data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      }
      return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
    },
  },
}
</script>

<style scoped>
/*
  O parcial do tema (app-chat.scss) assume so avatar + nome, e da pra
  .chat-info um width: calc(100% - 46px) fixo - sem sobrar espaco pra
  coluna de hora/contador que a gente acrescentou, ela empurra pra fora
  da lista (cortada). flex-basis proprio pros dois lados resolve.
*/
.chat-info {
  width: auto !important;
  flex: 1 1 auto;
  min-width: 0;
}
.chat-meta {
  flex: 0 0 auto;
  width: 46px;
}

/*
  4 abas ("Encerrados" e a mais longa) espremidas em ~350px de sidebar com
  nav-justified (largura igual pra cada) + padding/fonte padrao do tema
  cortam o texto. Reduzir os dois da conta.
*/
.nav-abas-atendimento .nav-link {
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  font-size: 0.78rem;
  white-space: nowrap;
}
</style>
